import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Clients() {
  const [loaded, setLoaded] = useState(false);

  const logos = [
    "/logoimages/axis.png",
    "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Vodafone_Idea_logo.svg/1200px-Vodafone_Idea_logo.svg.png",
    "https://1000logos.net/wp-content/uploads/2020/04/Tata-Logo.png",
    "https://1000logos.net/wp-content/uploads/2021/04/Jawa-logo.png",
    "https://upload.wikimedia.org/wikipedia/commons/7/7b/Honda_Logo.svg",
    "https://www.thirdwavecoffeeroasters.com/cdn/shop/files/TWC_logo_without_R-01.png?v=1695243143",
    "https://www.thepinkfoundry.com/cdn/shop/files/TPF-Logo-01.png?v=1649357550",
    "/logoimages/horlicks.png",
    "/logoimages/pei2.png",
    "/logoimages/Games24x777.png",
    "/logoimages/adda.png",
    "/logoimages/suzuki.png",
    "/logoimages/Starbucks.png",
    "/logoimages/Titan.png",
    "/logoimages/spellbee.png",
    "/logoimages/CORRA3.png",
    "/logoimages/microsoft3.png",
    "/logoimages/idfc2.png",
  ];

  const chunkSize = 12;
  const slides = [];
  for (let i = 0; i < logos.length; i += chunkSize) {
    slides.push(logos.slice(i, i + chunkSize));
  }

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    arrows: true,
    autoplay: true,
    speed: 700,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    adaptiveHeight: false,
  };

  // 🔥 IMPORTANT FIX: Force Slick to reinitialize after logos load
  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 300);
    return () => clearTimeout(timer);
  }, []);

  if (!loaded) return null; // prevents slick from rendering with width = 0

  return (
    <section id="clients" className="py-5">
      <div className="container text-center">
        <h2 className="h3 mb-5 fw-bold text-dark">Our Esteemed Clients</h2>

        <Slider {...settings}>
          {slides.map((slide, idx) => (
            <div key={idx}>
              
              <div
                className="d-flex justify-content-center flex-wrap"
                style={{ gap: "50px", marginBottom: "30px" }}
              >
                {slide.slice(0, 6).map((logo, i) => (
                  <div
                    key={i}
                    style={{
                      width: "150px",
                      height: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={logo}
                      alt="logo"
                      style={{
                        maxHeight: "70px",
                        objectFit: "contain",
                      }}
                      onLoad={() => setLoaded(true)} // ensures re-init after images load
                    />
                  </div>
                ))}
              </div>

              <div
                className="d-flex justify-content-center flex-wrap"
                style={{ gap: "50px" }}
              >
                {slide.slice(6, 12).map((logo, i) => (
                  <div
                    key={i}
                    style={{
                      width: "150px",
                      height: "100px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={logo}
                      alt="logo"
                      style={{
                        maxHeight: "70px",
                        objectFit: "contain",
                      }}
                      onLoad={() => setLoaded(true)}
                    />
                  </div>
                ))}
              </div>

            </div>
          ))}
        </Slider>

      </div>
    </section>
  );
}
